import { toRefs, reactive } from 'vue'
import { makeSelectorForm } from '@/components/material-selector/index.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'

export function getSplitText(text, textList) {
  const newlist = []
  const textArray = text.split(' ')
  for (const textItem of textArray) {
    const text = textItem.trim()
    if (!text) continue
    if (textList.includes(text)) continue
    if (newlist.includes(text)) continue
    newlist.push(text)
  }
  return newlist
}

export const useFormTextHanlder = (planForm) => {
  function onActionButtonsEnterKeyConfirm() {
    const { call_to_action_buttons, call_to_action_buttons_list } = planForm.value
    if (!call_to_action_buttons.trim()) return
    if (call_to_action_buttons_list.length >= 10) return
    const newlist = getSplitText(call_to_action_buttons, call_to_action_buttons_list)
    planForm.value.call_to_action_buttons_list = call_to_action_buttons_list.concat(newlist).slice(0, 10)
    planForm.value.call_to_action_buttons = ''
  }
  function onSellingPointsEnterKeyConfirm() {
    const { selling_points, selling_points_list } = planForm.value
    if (!selling_points.trim()) return
    if (selling_points_list.length >= 10) return
    const newlist = getSplitText(selling_points, selling_points_list)
    planForm.value.selling_points_list = selling_points_list.concat(newlist).slice(0, 10)
    planForm.value.selling_points = ''
  }

  function onTextAbstractEnterKeyConfirm() {
    const { text_abstract, text_abstract_list } = planForm.value
    if (!text_abstract.trim()) return
    if (text_abstract_list.length >= 10) return
    const newlist = getSplitText(text_abstract, text_abstract_list)
    planForm.value.text_abstract_list = text_abstract_list.concat(newlist).slice(0, 10)
    planForm.value.text_abstract = ''
  }

  return {
    onActionButtonsEnterKeyConfirm,
    onSellingPointsEnterKeyConfirm,
    onTextAbstractEnterKeyConfirm
  }
}

export const useMaterialSelector = () => {
  const seletorModel = reactive({
    showSelectorModal: false,
    selectorProps: {
      adAccountId: 6817,
      max: 1,
      assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO],
      // 108 头条产品主图默认尺寸
      form: { ...makeSelectorForm(), size: '108*108' }
    }
  })

  const onShowLogoSeletor = () => {
    seletorModel.showSelectorModal = true
  }
  const onSelectorClose = () => {}

  return {
    ...toRefs(seletorModel),
    onShowLogoSeletor,
    onSelectorClose
  }
}
